module.exports = __webpack_public_path__ + "static/media/sparkles.b0a27180.png";